// extracted by mini-css-extract-plugin
export default {"ordersCantainer":"Orders_ordersCantainer__2JlLj","pageContainer":"Orders_pageContainer__ydPll","pageTitle":"Orders_pageTitle__qpbvq"};